var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('b-card', {
    staticStyle: {
      "margin-left": "1%",
      "margin-right": "1%"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "uploadform"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "padding": "10px 0px 5px 0px",
      "color": "#fff"
    },
    attrs: {
      "for": "uploadPickupData"
    }
  }, [_c('a', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "font-size": "15px",
      "cursor": "pointer"
    },
    attrs: {
      "title": "Choose File to Upload"
    }
  }, [_vm._v("Choose\n                                        File "), _c('i', {
    staticClass: "fa fa-upload",
    staticStyle: {
      "color": "#fff"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "files",
    attrs: {
      "id": "uploadPickupData",
      "name": "uploadPickupData",
      "type": "file",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.uploadBookingData
    }
  }), _c('br'), _vm._v(" "), (_vm.showprogress) ? _c('span', [_c('span', [_vm._v("File Name")]), _vm._v(": " + _vm._s(_vm.filename) + " ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.uploadPickupData')),
      expression: "errors.has('uploadform.uploadPickupData')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Choose file to upload")])])]), _vm._v(" "), (_vm.filesource != '') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', {
    staticStyle: {
      "padding": "10px 0px 5px 0px",
      "color": "#fff"
    },
    attrs: {
      "for": "uploadPickupData"
    }
  }, [_c('a', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff",
      "font-size": "15px"
    },
    attrs: {
      "href": _vm.filesource,
      "target": "_blank",
      "title": "Download Template"
    }
  }, [_vm._v("Download Template\n                                      "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "color": "#fff"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-left": "48rem"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Submit",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.submitFile
    }
  }, [_vm._v("Submit "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v("  \n                                "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Reset"
    },
    on: {
      "click": _vm.resetform
    }
  }, [_vm._v("Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])], 1)])]), _vm._v(" "), (_vm.showprogress) ? _c('div', [_c('div', {
    staticClass: "progress-container"
  }, [_c('div', {
    class: _vm.progressarr[0] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.progressarr[0] == 'complete' ? 'circle-completed' : _vm.progressarr[0] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("1")]), _vm._v(" "), (_vm.progressarr[0] == 'stop') ? _c('span', [_vm._v("Uploade File")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[0] == 'start') ? _c('span', [_vm._v("Uploading")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[0] == 'complete') ? _c('span', [_vm._v("File Uploaded")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.progressarr[1] == 'complete') ? 'line' : (_vm.progressarr[1] == 'start') ? 'animated-line' : 'animated-line-disabled'
  }), _vm._v(" "), _c('div', {
    class: _vm.progressarr[1] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.progressarr[1] == 'complete' ? 'circle-completed' : _vm.progressarr[1] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("2")]), _vm._v(" "), (_vm.progressarr[1] == 'stop') ? _c('span', [_vm._v("Validate data.")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[1] == 'start') ? _c('span', [_vm._v("Validating - " + _vm._s(_vm.validateddata) + " out of " + _vm._s(_vm.totaldata) + " records")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[1] == 'complete') ? _c('span', [_vm._v("Validated - " + _vm._s(_vm.validateddata) + " out of " + _vm._s(_vm.totaldata) + " records")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.progressarr[2] == 'complete') ? 'line' : (_vm.progressarr[2] == 'start') ? 'animated-line' : 'animated-line-disabled'
  }), _vm._v(" "), _c('div', {
    class: _vm.progressarr[2] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.progressarr[2] == 'complete' ? 'circle-completed' : _vm.progressarr[2] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("3")]), _vm._v(" "), (_vm.progressarr[2] == 'stop') ? _c('span', [_vm._v("Import Valid record.")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[2] == 'start') ? _c('span', [_vm._v("Importing Valid record.")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[2] == 'complete') ? _c('span', [_vm._v("Import Completed.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: (_vm.progressarr[3] == 'complete') ? 'line' : (_vm.progressarr[3] == 'start') ? 'animated-line' : 'animated-line-disabled'
  }), _vm._v(" "), _c('div', {
    class: _vm.progressarr[3] == 'stop' ? 'circle-disabled' : ''
  }, [_c('span', {
    class: _vm.progressarr[3] == 'complete' ? 'circle-completed' : _vm.progressarr[3] == 'start' ? 'circle circle-loading' : 'circle'
  }, [_vm._v("4")]), _vm._v(" "), (_vm.progressarr[3] == 'stop') ? _c('span', [_vm._v("Pending.")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[3] == 'start') ? _c('span', [_vm._v("completed.")]) : _vm._e(), _vm._v(" "), (_vm.progressarr[3] == 'complete') ? _c('span', [_vm._v("Completed.")]) : _vm._e()])]), _vm._v(" "), (_vm.showSpinner) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-spin",
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                            File is processing. Please do not refresh.\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.showError) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                            Please correct the file and upoad again.\n                        ")])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showresult == true),
      expression: "showresult==true"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upload Details")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Valid Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Invalid Records")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.totalRecords))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Vaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadResultData('valid')
      }
    }
  }, [_vm._v(_vm._s(_vm.successRecords.length))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Invaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadResultData('invalid')
      }
    }
  }, [_vm._v(_vm._s(_vm.failedRecords.length))])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showuploadresult == true),
      expression: "showuploadresult==true"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showimportbutton == true),
      expression: "showimportbutton==true"
    }],
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Import Valid Records",
      "disabled": _vm.disableimport
    },
    on: {
      "click": _vm.importValidRecords
    }
  }, [_vm._v("Import Valid Records "), _c('i', {
    staticClass: "fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showimportbutton == false),
      expression: "showimportbutton==false"
    }],
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Download Invalid Records"
    },
    on: {
      "click": _vm.downloadFile
    }
  }, [_vm._v("Download Invalid Records "), _c('i', {
    staticClass: "fa fa-arrow-circle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showuploadresult) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Branch/hub name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Branch/hub id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Route Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("FM Pincodes")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("LM Pincodes")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.fmpincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lmpincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }))])])]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0px 2%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox",
      "name": "Uploadedfile",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("File Upload Log")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "isEditHidden": true,
      "offset": _vm.offset
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }, [_c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showViewUploadResult == true),
      expression: "showViewUploadResult==true"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upload Details")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Total Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Valid Records")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Invalid Records")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.totalUploadRecords))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Vaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadViewResultData('valid')
      }
    }
  }, [_vm._v(_vm._s(_vm.uploadsuccessRecords.length))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    attrs: {
      "title": "Invaild Records"
    },
    on: {
      "click": function($event) {
        _vm.openUploadViewResultData('invalid')
      }
    }
  }, [_vm._v(_vm._s(_vm.uploadfailedRecords.length))])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showviewuploadresult == true),
      expression: "showviewuploadresult==true"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "5px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "5px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showviewuploadresult) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Branch/hub name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Branch/hub id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Route Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("FM Pincodes")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("LM Pincodes")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.viewuploadResultData), function(data, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.fmpincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lmpincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))])])
  }))])])]) : _vm._e()])])])], 1)])])])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-814973c2","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/Autoallocation/uploadrequestedroute/uploadrequestedroute.component.html
// module id = 1955
// module chunks = 3